import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Asset } from '../../models/Asset';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AssetSearchCommand } from '../../models/commands/AssetSearchCommand';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class AssetProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/asset';

  getAssets(): Observable<ApiResponse<Asset[]>> {
    return this.httpClient.get<ApiResponse<Asset[]>>(`${this.baseUrl}/all`);
  }

  getAssetById(id: string): Observable<ApiResponse<Asset>> {
    return this.httpClient.get<ApiResponse<Asset>>(`${this.baseUrl}/${id}`);
  }

  upsertAsset(asset: Asset): Observable<ApiResponse<Asset>> {
    return this.httpClient.post<ApiResponse<Asset>>(`${this.baseUrl}`, asset);
  }

  searchAssets(
    command: AssetSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<Asset>>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder ?? -1}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Asset>>>(url, command);
  }
}
